(function () {
    'use strict';

    angular
        .module('surveyCampaignsRoutes', ['oddRoutes', 'surveyCampaignsModule'])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider

            // Survey Campaigns
            .state('odd.surveyCampaigns', {
                url: '/Campaigns',
                resolve: {
                    campaigns: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getAllCampaignsByBusinessUnit(businessUnit.ODDBusinessUnitID);
                    }]
                },
                views: {
                    'surveyCampaigns': {
                        controller: 'SurveyCampaignListController',
                        templateUrl: require('./surveyCampaignList.tpl.html')
                    }
                }
            })

            // Create Campaign
            .state('odd.surveyCampaigns.add', {
                url: '/Add',
                resolve: {
                    campaign: ['$stateParams', 'businessUnit', 'authenticatedUser', function ($stateParams, businessUnit, authenticatedUser) {
                        return {
                            ODDBusinessUnitID: businessUnit.ODDBusinessUnitID,
                            Owner: authenticatedUser.MetaDataUser,
                            OwnerID: authenticatedUser.MetaDataUser.ItemPersonID
                        };
                    }]
                },
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignAddController',
                        templateUrl: require('./surveyCampaignAdd.tpl.html')
                    }
                }
            })
            .state('odd.surveyCampaignEdit', {
                url: '/Campaign/{ODDCampaignID:int}',
                resolve: {
                    campaign: ['$stateParams', 'oddCampaignService', 'businessUnit', function ($stateParams, service, businessUnit) {
                        return service.getSurveyCampaign(businessUnit.ODDBusinessUnitID, $stateParams.ODDCampaignID);
                    }],
                    questionnaireTemplate: ['oddSurveyQuestionnaireTemplateService', 'campaign', function (service, campaign) {
                        return service.getQuestionnaire(campaign.ODDBusinessUnitID, campaign.ODDCampaignID);
                    }],
                    campaignRespondents: ['oddCampaignRespondentService', 'campaign', function (service, campaign) {
                        return service.getCampaignRespondents(campaign.ODDBusinessUnitID, campaign.ODDCampaignID);
                    }]
                },
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignEditController',
                        templateUrl: require('./surveyCampaignEdit.tpl.html')
                    }
                }
            })
            .state('odd.surveyCampaignEdit.inviteDetails', {
                url: '/InviteDetails',
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignInviteDetailsEditController',
                        templateUrl: require('./surveyCampaignInviteDetailsEdit.tpl.html')
                    }
                }
            })
            .state('odd.surveyCampaignEdit.section', {
                url: '/QuestionnaireTemplate/{ODDQuestionnaireID:int}/Section/{ODDSectionID:int}',
                resolve: {
                    questionnaireSection: ['$stateParams', 'businessUnit', 'oddSurveyQuestionnaireTemplateService', function ($stateParams, businessUnit, service) {
                        return service.getSection(businessUnit.ODDBusinessUnitID, $stateParams.ODDQuestionnaireID, $stateParams.ODDSectionID);
                    }]
                },
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignQuestionnaireSectionEditController',
                        templateUrl: require('./surveyCampaignQuestionnaireSectionEdit.tpl.html')
                    }
                }
            })

            .state('odd.surveyCampaignEdit.addSection', {
                url: '/QuestionnaireTemplate/{ODDQuestionnaireID:int}/AddSection',
                resolve: {
                    questionnaireTemplate: ['businessUnit', 'campaign','oddSurveyQuestionnaireTemplateService', function (businessUnit, campaign, service) {
                        return service.getQuestionnaire(businessUnit.ODDBusinessUnitID, campaign.ODDCampaignID);
                    }],
                    questionnaireSection: ['$stateParams', 'businessUnit', function ($stateParams, businessUnit) {
                        return {
                            ODDBusinessUnitID: businessUnit.ODDBusinessUnitID,
                            ODDQuestionnaireID: $stateParams.ODDQuestionnaireID
                        };
                    }]
                },
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignQuestionnaireSectionEditController',
                        templateUrl: require('./surveyCampaignQuestionnaireSectionEdit.tpl.html')
                    }
                }
            })
            .state('odd.surveyCampaignEdit.section.editComponentList', {
                 url: '/Components',
                 views: {
                     'surveyCampaigns@odd': {
                         controller: 'SurveyCampaignComponentListEditController',
                         templateUrl: require('./SurveyCampaignComponentListEdit.tpl.html')
                     }
                 }
            })
            .state('odd.surveyCampaignEdit.section.questionEdit', {
                 url: '/Question/{ODDQuestionID:int}',
                 views: {
                     'surveyCampaigns@odd': {
                         controller: 'SurveyCampaignQuestionEditController',
                         templateUrl: require('./surveyCampaignQuestionEdit.tpl.html'),
                         resolve: {
                             oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                                 return service.getQuestionFieldTypes();
                             }],
                             oddQuestionType: ['oddQuestion', 'oddQuestionnaireTemplateService', function (oddQuestion, service) {
                                 return service.getQuestionTypeByCode(oddQuestion.ODDQuestionType.Code).then(function (questionType) {
                                     oddQuestion.ODDQuestionType = questionType;
                                 });
                             }],
                             oddQuestion: ['$stateParams', 'businessUnit', 'oddQuestionnaireTemplateService', function ($stateParams, businessUnit, service) {
                                 return service.getQuestion(businessUnit.ODDBusinessUnitID, $stateParams.ODDQuestionnaireID, $stateParams.ODDSectionID, $stateParams.ODDQuestionID)
                             }]
                         }
                     }
                 }
             })

            .state('odd.surveyCampaignEdit.section.addQuestion', {
                   url: '/Question/Add/OfType/{ODDQuestionTypeCode:string}',
                   resolve: {
                       oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                           return service.getQuestionFieldTypes();
                       }],
                       oddQuestionType: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                           return service.getQuestionTypeByCode($stateParams.ODDQuestionTypeCode)
                       }],
                       oddQuestion: ['oddQuestionType', function(oddQuestionType) {
                           return { ODDQuestionTypeID: oddQuestionType.ODDQuestionTypeID, ODDQuestionType: oddQuestionType };
                       }]
                   },
                   views: {
                       'surveyCampaigns@odd': {
                           controller: 'SurveyCampaignQuestionEditController',
                           templateUrl: require('./surveyCampaignQuestionEdit.tpl.html')
                       }
                   }
               })

            .state('odd.surveyCampaignEdit.section.addQuestionTemplate', {
                url: '/Question/Add/OfType/{ODDQuestionTypeCode:string}/{ODDQuestionChoiceTemplateID:int}',
                resolve: {
                    oddQuestionFieldTypes: ['oddQuestionnaireTemplateService', function (service) {
                        return service.getQuestionFieldTypes();
                    }],
                    oddQuestionChoiceTemplate: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                        return service.getQuestionMultiChoiceTemplate($stateParams.ODDQuestionChoiceTemplateID)
                    }],
                    oddQuestionType: ['$stateParams', 'oddQuestionnaireTemplateService', function ($stateParams, service) {
                        return service.getQuestionTypeByCode($stateParams.ODDQuestionTypeCode)
                    }],
                    oddQuestion: ['oddQuestionType', 'oddQuestionChoiceTemplate', function(oddQuestionType, oddQuestionChoiceTemplate) {
                        return {
                            ODDQuestionTypeID: oddQuestionType.ODDQuestionTypeID,
                            ODDQuestionType: oddQuestionType,
                            ODDQuestionChoiceTemplate: oddQuestionChoiceTemplate,
                            ODDQuestionChoiceTemplateID: oddQuestionChoiceTemplate.ODDQuestionChoiceTemplateID
                        };
                    }]
                },
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignQuestionEditController',
                        templateUrl: require('./surveyCampaignQuestionEdit.tpl.html')
                    }
                }
            })
            .state('odd.surveyCampaignEdit.editSectionList', {
                  url: '/Sections',
                  views: {
                      'surveyCampaigns@odd': {
                          controller: 'SurveyCampaignSectionListEditController',
                          templateUrl: require('./surveyCampaignSectionListEdit.tpl.html')
                      }
                  }
            })
            .state('odd.surveyCampaignEdit.respondentList', {
                url: '/Respondents',
                views: {
                    'surveyCampaigns@odd': {
                        controller: 'CampaignRespondentListController',
                        templateUrl: require('./campaignRespondentList.tpl.html')
                    }
                }
            })

           .state('odd.surveyCampaignEdit.section.staticTextEdit', {
               url: '/{ODDStaticTextID:int}',
               resolve: {
                   oddStaticText: ['$stateParams', 'businessUnit', 'questionnaireSection', 'oddSurveyQuestionnaireTemplateService', function ($stateParams, businessUnit, questionnaireSection,service) {
                       return service.getStaticText(businessUnit.ODDBusinessUnitID, questionnaireSection.ODDQuestionnaireID, questionnaireSection.ODDSectionID, $stateParams.ODDStaticTextID);
                   }],
               },
               views: {
                    'surveyCampaigns@odd': {
                        controller: 'SurveyCampaignStaticTextEditController',
                        templateUrl: require('./surveyCampaignQuestionnaireStaticTextEdit.tpl.html')
                    }
            }
         })

         .state('odd.surveyCampaignEdit.section.addStaticText', {
             url: '/StaticText/Add',
             resolve: {
                 oddStaticText: function () { return {}; }
             },
             views: {
                 'surveyCampaigns@odd': {
                     controller: 'SurveyCampaignStaticTextEditController',
                     templateUrl: require('./surveyCampaignQuestionnaireStaticTextEdit.tpl.html')
                 }
             }
         });


    }
})();
